import { Form, Input, Typography, theme } from 'antd';
import { useMaintanceToDo } from 'providers/MaintanceToDoProvider';
import React from 'react';

const GeneralMaintanceToDoForm = ({ observaciones }) => {
  const { handleObservaciones } = useMaintanceToDo();
  const { token } = theme.useToken();

  return (
    <div style={{ marginTop: token.marginLG, paddingTop: token.paddingMD }}>
      <Typography.Text
        style={{
          display: 'block',
          fontSize: token.fontSizeSM,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: token.colorTextSecondary,
          marginBottom: token.marginXS,
          fontWeight: token.fontWeightStrong,
        }}
      >
        Observación general de la mantención
      </Typography.Text>
      <Form>
        <Form.Item initialValue={observaciones} name={'observaciones'} style={{ marginBottom: 0 }}>
          <Input.TextArea
            onChange={(e) => handleObservaciones(e.target.value)}
            rows={4}
            placeholder="Ingresar Observaciones generales"
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default GeneralMaintanceToDoForm;
